<template>
  <div :class="getCss('wrap')" :style="styles.base">
    <template>
      <div :class="getCss('login')" :style="styles.fontStyle" v-if="isLogin">
        <div :style="styles.fontStyle">
          你好，
          <template>
            <span :class="getCss('userinfo-text')" v-if="!isRoleReady && isWX " v-html="userName"></span>
            <span :class="getCss('userinfo-text')" v-if="!isRoleReady && !isWX" v-text="userName"></span>
            <span :class="getCss('userinfo-text')">{{ partitionName }}</span>
            <span :class="getCss('userinfo-text')">{{ roleName }}</span>
          </template>
        </div>
        <div>
          <a
            v-if="showRole"
            :class="getCss('userinfo-text-button')"
            @click="handleBindRole"
          >{{ userBindText }}</a>
          <a
            v-if="!configurationData.disableRewardRecord"
            :class="getCss('userinfo-text-button')"
            @click="handleClaimRecord"
          >领奖记录</a>
          <a
            v-if="!configurationData.disableRechargeRecord"
            :class="getCss('userinfo-text-button')"
            @click="handleRechargeRecord"
          >充值记录</a>
          <br v-if="configurationData.showBindQQ &&
           configurationData.showBindPhone && configurationData.showAccessMakeAppShortCut">
          <a
            v-if="configurationData.showBindQQ"
            :class="getCss('userinfo-text-button')"
            @click="showBindQQFunc"
          >{{ bindBtnText }}</a>
          <a
            v-if="configurationData.showBindPhone"
            :class="getCss('userinfo-text-button')"
            @click="showBindPhoneFunc"
          >绑定手机</a>
          <a
            v-if="configurationData.showAccessMakeAppShortCut"
            :class="getCss('userinfo-text-button')"
            @click="showAccessMakeAppShortCutFunc"
          >添加快捷方式</a>
          <a :class="getCss('userinfo-text-button')"
             v-if="showLogout"
             @click="handleLogout">注销</a>
        </div>
      </div>
      <div :class="getCss('not-login')" v-else :style="styles.fontStyle">
        你好，请
        <template v-if="isWX || isSafari">
          <span>
            <a id="ptLoginBtn" @click="loginByQQ">【QQ登录】</a>
          </span>
          <!-- 如果是端游的 不显示微信登录并且 禁止微信登录         -->
          <span v-if="!isClientGame">
            或
            <a id="wxloginBtn" @click="loginByWx">【微信登录】</a>
          </span>
        </template>
        <template v-else>
          <span>
            <a id="ptLoginBtn" @click="loginByQQ">【QQ登录】</a>
          </span>
        </template>
      </div>
    </template>

  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin, common, baseComponents } from '@tencent/ceiba-base-components';
// import { componentBaseMixin, common, baseComponents } from '../../../../ceiba-base-components';
import CDialog from '@tencent/ceiba-base-components/src/components/base-dialog';

export default {
  name: 'CTgclubUserArea',
  components: { [CDialog.name]: CDialog },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'tgclub-user-area-',
      showSwitchLogin: false,
      showControl: false,
    };
  },
  computed: {
    // 端游判断
    isClientGame() {
      return this.$actInfo && this.$actInfo.game_type === 1;
    },
    bindBtnText() {
      return this.configurationData.bind_btn_text || '绑定QQ';
    },
    isWX() {
      //  ios safari | 心悦app | wx客户端
      const isWxCookie = common.tool.getCookie('acctype') === 'wx';
      console.log('isWxCookie = ', isWxCookie);
      return isWxCookie ? isWxCookie : this.$platform.isWX;
    },
    wrapStyle() {
      const fontStyle = this.styles.fontStyle || {};
      return {
        ...this.styles.base,
        ...fontStyle,
      };
    },
    showRole() {
      const bushandang = this.actInfo.extendConfig.bushandang || false;
      if (bushandang) {
        return this.isRoleStatusValid;
      }
      return this?.actInfo?.extendConfig?.forceRole;
    },
    disableLogout() {
      return this.$actInfo && this.$ast.isAPP();
    },
    userBindText() {
      return this.isRoleReady ? '更改绑定' : '绑定角色';
    },
    userName() {
      return this.isLogin ? this.userInfo.nickName : '';
    },
    partitionName() {
      return this.isRoleReady ? common.tool.Base64.decode(this.roleInfo.partition_name || '') : '';
    },
    roleName() {
      if (this.isRoleReady) {
        return common.tool.Base64.decode(this.roleInfo.role_name || '');
      }
      return '';
    },
    showLogout() {
      const isShanxianApp = /com\.tencent\.gamecommunity/.test(window.navigator.userAgent);
      const isBbApp = !!window.navigator.userAgent.match(/gamehelper/i);
      if (isShanxianApp || isBbApp) {
        return false;
      }
      return this.$actInfo && !this.$ast.isAPP();
    },
    isSafari() {
      return /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
    },
  },
  mounted() {
    console.log('version 1.0.10 tgclub user area  configurationData=', this.configurationData);
    this.initialize();
  },
  methods: {
    initialize() {
      // 用户登陆
      this.$eventBus.$onLogined(this.handleLogin);
    },
    async loginByQQ() {
      this.login({
        loginType: 'qq',
      });
      this.handleClickEvent();
    },
    async loginByWx() {
      this.login({
        loginType: 'wx',
      });
      this.handleClickEvent();
    },
    async handleLogout() {
      this.logout();
    },

    async handleLogin() {
      // 自动绑定角色
      const bushandang = this.actInfo.extendConfig.bushandang || false;
      if (bushandang) {
        if (this.isRoleStatusValid) {
          this.checkRoleInfo();
        }
      } else {
        if (this?.actInfo?.extendConfig?.forceRole) {
          this.checkRoleInfo();
        }
      }
      const { isUserReported = false } = this.configurationData;
      // 只需要 微信端上报
      if (isUserReported && this.isWX) {
        const res = await this.$axiosInstance.get('https://wang.xinyue.qq.com/api/headurl/update');
        console.log(res, '登录态头像上报res');
      }
      if (this.isClientGame && this.isWX) {
        this.$confirm({
          msg: '端游仅限QQ登录',
          cancel() {
            console.log('cancel 端游仅限QQ登录');
          },
          confirm() {
            console.log('confirm 端游仅限QQ登录');
          },
        });
      }
    },
    async handleBindRole() {
      try {
        console.log('user access click handleBindRole');
        baseComponents.gameRoleSelect.showGameRoleSelect(this.currentGameCode || this.actInfo.game_code, {})
          .then((roleInfo) => {
            console.log('select role=', roleInfo);
            this.saveCurrentRole({
              isRoleReady: true,
              roleInfo,
            });
            this.reportReturnGameFlow(roleInfo);
          })
          .catch((response) => {
            console.error('action bind role fail  response =', response);
          });
      } catch (err) {
        console.error('action bind role fail catch  error =', err);
      }
    },
    // 上报回流
    reportReturnGameFlow(roleInfo) {
      const { reportReturnGameFlowId = 0 } = this.configurationData;
      console.log('access report after report  role=', roleInfo, reportReturnGameFlowId);
      console.log('access report after report  this.role=', this.roleInfo, reportReturnGameFlowId);
      if (reportReturnGameFlowId > 0 && roleInfo) {
        console.log('access report after report  role=', roleInfo, reportReturnGameFlowId);
        this.flowRequest({
          flowId: reportReturnGameFlowId,
          params: {
            role: roleInfo,
          },
        }).then(res => console.log('用户回流上报流程reportReturnGameFlowId =', reportReturnGameFlowId, '请求返回 = ', res));
      }
    },
    showBindPhoneFunc() {
      this.$eventBus.$emit('ceiba:custom:events:call:use:bind:phone:pop', {});
      console.log('ceiba:custom:events:call:use:bind:phone:pop event');
    },
    showBindQQFunc() {
      this.$eventBus.$emit('ceiba:common:event:account-wx-qq-fill', {});
      console.log('ceiba:common:event:account-wx-qq-fill event');
    },
    // 快捷方式
    showAccessMakeAppShortCutFunc() {
      this.$eventBus.$emit('ceiba:custom:events:call:use:add:shortcut', {});
    },
    async handleClaimRecord() {
      const { isMoreGameActAndHasGeneralLottery = false, gameCodeListStr = '', recordsTitleFontColor = '' } = this.configurationData;
      const gameCodeListArr = gameCodeListStr.split('|');
      // 切换游戏，如果多游戏抽奖/领取同用一个礼包单，game code则为tgclub
      const gameCode = isMoreGameActAndHasGeneralLottery && gameCodeListArr.indexOf(this.currentGameCode) > -1
        ? 'tgclub'
        : (this.configurationData?.game_code || this.currentGameCode);
      const pageSize = this.configurationData.popupPageSize || 6; // 每页记录数可配置,默认6
      baseComponents.pacakgeClaimRecords.showPackageClaimRecords(gameCode, {
        hidePackageIds: (this.configurationData.hidePackageIds || '').split(','),
        params: {
          activity_id: this.actInfo.activity_id.toString(),
          business_id: this.actInfo.ast,
          resource_id: this.configurationData?.resource_id ? `${this.configurationData.resource_id}` : '',
          flow_version: this.actInfo.flow ? parseInt(this.actInfo.flow, 10) : 1,
          moduleId: this.configurationData?.moduleId ? `${this.configurationData.moduleId}` : '',
          category: this.configurationData?.category ? `${this.configurationData.category}` : '',
          iExcludePackageId: this.configurationData?.iExcludePackageId ? `${this.configurationData.iExcludePackageId}` : '',
          scene: this.configurationData?.scene ? `${this.configurationData.scene}` : 'ceiba_act',
        },
        pageSize,
        option: {
          header: false,
          footer: false,
          height: '3.6rem',
          width: '7.2rem',
          closeLocation: 'top-right',
          close: true,
          titleStyle: {
            color: recordsTitleFontColor,
          },
          dialogStyle: Object.assign(
            {},
            {
              color: this.configurationData.recordsFontColor || '#000000',
              backgroundImage: `url(${this.configurationData.packageClaimBackgroundImage})`,
            },
          ),
        },
      });
    },
    async handleRechargeRecord() {
      if (!this.roleInfo.role_id && this.showRole) {
        this.$alert({ msg: '请先绑定角色' });
        return false;
      }
      const myRoleInfo = this.roleInfo;
      baseComponents.rechargeRecord.showRechargeRecord({
        thisFlowRequest: this.flowRequest,
        myRoleInfo,
        payBusiness: this.configurationData.payBusiness,
        sellChannel: this.configurationData.sellChannel,
        flowId: this.configurationData.rechargeRecordFlowId,
        spInfo: '',
        pageSize: 6,
        option: {
          header: false,
          footer: false,
          height: '3.6rem',
          width: '7.2rem',
          closeLocation: 'top-right',
          close: true,
          dialogStyle: Object.assign(
            {},
            {
              color: this.configurationData.rechargeRecordFontColor || '#000000',
              backgroundImage: `url(${this.configurationData.rechargeRecordBackgroundImage})`,
            },
          ),
        },
      });
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';

.pop-login .qq-login {
  margin-right: 90px;
  display: inline-block;
  width: 145px;
  height: 145px;
  background: url(https://act.xinyue.qq.com/activity/ingame/10009/7625d4358e727be901f2fa8fe4c19653.png) no-repeat center top;
}

.pop-login .wechat-login {
  display: inline-block;
  width: 145px;
  height: 145px;
  background: url(https://act.xinyue.qq.com/activity/ingame/10009/685e8ab1c56cbc685b97f5ec9d37f502.png) no-repeat center top;
}
</style>
